import React from 'react'
import { useNavigate } from 'react-router-dom'

import TicketForm from '../components/tickets/TicketForm'

// SubmitTicketPage (design: Pages and UI components; Req 1.1, 1.2)
//
// Renders TicketForm for customers so they can submit a new ticket. TicketForm
// itself writes the ticket via addDoc; this page only supplies the right props
// and navigates to the created ticket on success. Admins are told they cannot
// submit tickets, and users with no resolved role get the "access pending"
// state (Error Handling: Unresolved role, Req 8.6).
const SubmitTicketPage = ({ role, customer, user }) => {
  const navigate = useNavigate()

  const admin = role === 'admin'
  const customerId = customer?.id || null
  const customerName = customer?.name
  const authorEmail = user?.email

  // Admins don't submit tickets on their own behalf.
  if (admin) {
    return (
      <div className='p-4 max-w-4xl mx-auto'>
        <p className='text-gray-600'>Only customers can submit tickets.</p>
      </div>
    )
  }

  // Unresolved role: no admin and no customer id.
  if (!customerId) {
    return (
      <div className='p-4 max-w-4xl mx-auto'>
        <p className='text-gray-600'>
          Your access is pending. Please contact support.
        </p>
      </div>
    )
  }

  return (
    <div className='p-4 max-w-3xl mx-auto text-left'>
      <div className='mb-6'>
        <h1 className='text-3xl font-bold text-gray-900'>Submit a Ticket</h1>
        <p className='mt-1 text-sm text-gray-500'>Tell us what's going on and we'll get back to you.</p>
      </div>
      <div className='rounded-lg border border-gray-200 bg-white p-6 shadow-sm'>
        <TicketForm
          customerId={customerId}
          customerName={customerName}
          authorEmail={authorEmail}
          isMediproCustomer={customer?.isMediproCustomer}
          isAcaproCustomer={customer?.isAcaproCustomer}
          onSubmitted={(id) => navigate('/tickets/' + id)}
        />
      </div>
    </div>
  )
}

export default SubmitTicketPage
